import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useMotionPreference } from '../../hooks/useMotionPreference';
export function RollingCounter({
  value,
  className = ''
}: {
  value: number | string;
  className?: string;
}) {
  const reduce = useMotionPreference();
  return <span className={`relative inline-flex overflow-hidden tabular-nums ${className}`} aria-live="polite" data-id="element-1368" data-mp="2rfw8iqgm12cy">
      <AnimatePresence mode="popLayout" initial={false} data-id="element-1369" data-mp="2nekfsc2fw10j">
        <motion.span key={value} initial={reduce ? {
        opacity: 0
      } : {
        y: '100%',
        opacity: 0
      }} animate={{
        y: '0%',
        opacity: 1
      }} exit={reduce ? {
        opacity: 0
      } : {
        y: '-100%',
        opacity: 0
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-1370" data-mp="2ng5e8crvk43o">
          {value}
        </motion.span>
      </AnimatePresence>
    </span>;
}